module.exports = __webpack_public_path__ + "img/white-np-logo.7ecf428d.svg";